<template>

    <v-card class="border-lg border-primary border-opacity-100">
        <v-card-title>
            <TitleOfDialog title="Users" @close="emit('close')" />
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
            <v-btn class="mb-3" width="100%" prepend-icon="mdi-plus-thick" color="primary"
                :disabled="!user_perms.find(e => e.name == 'create_user')" @click="dialogAddUser = true">Add
                user</v-btn>
            <v-data-table :items-per-page-options="[10]" :loading="loading" :items="users || []"
                :items-length="users.length" :headers="headers" @update:options="loadItems" class="elevation-1">
                <template v-slot:item.actions="{ item }">
                    <v-btn :disabled="!user_perms.find(e => e.name == 'edit_user')" icon color="primary" variant="text"
                        @click="editUser(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn :disabled="!user_perms.find(e => e.name == 'delete_user')" icon color="error" variant="text"
                        @click="deleteUser(item)">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>

    </v-card>

    <v-overlay v-model="dialogAddUser" location="top" style="justify-content:center;align-items: center;">
        <AddUserForm @close="dialogAddUser = false"></AddUserForm>
    </v-overlay>

    <v-overlay v-model="dialogEditUser" location="top" style="justify-content:center;align-items: center;">
        <EditUserForm :user="userToEdit" @close="dialogEditUser = false"></EditUserForm>
    </v-overlay>

    <v-overlay v-model="dialogDeleteUser" location="top" style="justify-content:center;align-items: center;">
        <ConfirmForm @close="dialogDeleteUser = false" @confirm="confirmDeleteUser()"
            :text="'Do you want to delete user ' + userToDelete.name + 'with email ' + userToDelete.email"
            type-to-delete="User"></ConfirmForm>
    </v-overlay>

</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/store/userStore';
import AddUserForm from '@/components/admin/forms/AddUserForm.vue';
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import ConfirmForm from '@/components/admin/forms/ConfirmForm.vue';
import EditUserForm from '@/components/admin/forms/EditUserForm.vue';

const emit = defineEmits(['close']);
const props = defineProps({
    user_perms: Object
})
const dialogAddUser = ref(false);
const dialogEditUser = ref(false);
const dialogDeleteUser = ref(false);

const userToEdit = ref();
const userToDelete = ref();

const headers = computed(() => [
    { title: "Name", align: 'left', sortable: false, key: 'name' },
    { title: 'Email', align: 'center', sortable: false, key: 'email' },
    { title: 'Rol', align: 'center', sortable: false, key: 'role' },
    { title: 'Actions', align: 'center', sortable: false, key: 'actions' },
]);

const loading = ref(true);
const userStore = useUserStore();
const { users } = storeToRefs(userStore);
const loadItems = async () => {
    loading.value = true;
    await userStore.fetchUsers();
    loading.value = false;
}


const editUser = (user) => {
    userToEdit.value = user;
    dialogEditUser.value = true;
};

const deleteUser = (user) => {
    userToDelete.value = user;
    dialogDeleteUser.value = true;
};

const confirmDeleteUser = async () => {
    try {
        await userStore.deleteUser(userToDelete.value.id);
        dialogDeleteUser.value = false;
    } catch (error) {
        console.error("Error en la validación o creación del usuario:", error);
    }
}
</script>